import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services/core/authentication.service';
import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { CollectionManagerService } from '../../services/core/collection-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-password-reset',
	templateUrl: './password-reset.component.html',
	styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
	sections: any = [];
	errors: any = [];
	email = "";
	hash = "";
	currentUser: any = [];
	linkValid: boolean = true;
	password = "";
	repeatPassword = "";
	errormessage = false;
	successmessage = false;
	changepassword = false;
	errorPasswordRequired = false;
	errorInvalidPassword = false;
	passwordValid = false;
	errorPasswordMatch = false;
	passwordMatchValid = false;

	successRecovery = false;
	showInvalidMessage = true;

	invalidMsg = "Je activatielink is verlopen. Vraag direct een een nieuwe activatielink aan.";

	constructor(
		public appService: AppService,
		public api: ApiConnectionService,
		public router: Router,
		public authenticationService: AuthenticationService,
		public collectionManager: CollectionManagerService,
		private route: ActivatedRoute,
		private ngxLoader: NgxUiLoaderService
	) {
		let self = this;
		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
			} else {
				self.currentUser = false;
			}
		});

		self.appService.setDefaultAuthor();
		this.appService.setShowCheckRequestAlert();
	}

	resetValidation() {
		this.errorPasswordRequired = false;
		this.passwordValid = false;

		this.passwordMatchValid = false;
		this.errorPasswordMatch = false;

		this.errors = [];
	}

	checkPassword(event) {
		if (this.password.length < 3) {
			this.passwordValid = false;
		} else {
			this.passwordValid = true;
		}
	}

	checkMatch(event) {
		if (this.repeatPassword.length < 3) {
			this.passwordMatchValid = false;
			this.errorPasswordMatch = false;
		} else if (this.repeatPassword == this.password) {
			this.passwordMatchValid = true;
			this.errorPasswordMatch = false;
		} else {
			this.passwordMatchValid = false;
			this.errorPasswordMatch = true;
		}
	}

	ngOnInit(): void {
		this.appService.navActive();
		this.appService.setPageTitle('Wachtwoord instellen');
		this.appService.setPageDescription('');

		let self = this;
		this.ngxLoader.start();
		self.authenticationService.getCurrentUser().then(function (response) {
			self.ngxLoader.stop();
		});

		let hash = this.route.snapshot.paramMap.get('hash');
		let email = this.route.snapshot.paramMap.get('email');

		self.hash = hash;
		if (email.includes('@')) {
			email = btoa(email);
		} else {
			email = email;
		}

		self.email = atob(email);

		self.api.read('users/checkResetHash/' + hash + '/' + email + '').then(function (response) {
			self.linkValid = true;
		}).catch(function (response) {
			self.linkValid = false;
		});

		self.appService.setDefaultMeta();
	}

	goToPasswordReset() {
		this.appService.showPasswordResetModal(null);
	}

	requestPasswordRecovery() {
		let self = this;
		self.errors = [];
		self.successmessage = false;
		self.errormessage = false;

		let email = "";
		if (!email.includes('@')) {
			email = self.email;
			console.log("1: " + email);
		} else {
			email = self.email;
			console.log("2: " + email);

		}

		this.ngxLoader.start();
		this.api.save('users/passwordRecovery', { email: email}).then((response) => {
			self.ngxLoader.stop();
			self.successRecovery = true;
			self.showInvalidMessage = false;
		}).catch(function (response) {
			self.invalidMsg = response.error.email;
			self.ngxLoader.stop();
		});
	}

	save() {
		let self = this;
		self.errors = [];
		self.successmessage = false;
		self.errormessage = false;

		let password = self.password;
		let repeatPassword = self.repeatPassword;

		password = encodeURIComponent(password);
		repeatPassword = encodeURIComponent(repeatPassword);
		
		let email = btoa(self.email);

	    this.ngxLoader.start();
		this.api.save('users/resetPassword/'+self.hash+'/'+email+'&type=base64', { password: password, repeatPassword: repeatPassword }).then((response) => {
	      self.ngxLoader.stop();
	      self.successmessage = true;
		}).catch (function (response) {
			self.ngxLoader.stop();
			self.errormessage = true;
			for (let error in response['error']['errors']) {
				self.errors[error] = response['error']['errors'][error];
			}
		});
	}
}
